import cn from "classnames"
import { Fragment } from "react"

import { Descriptions as DescriptionsAntd, Skeleton } from "antd"
import { DividerDescription } from "./DividerDescription"
import { LabelDescriptions } from "./LabelDescriptions"
import { TitleDescriptions } from "./TitleDescriptions"

import type { DescriptionsProps } from "."

import styles from "./Descriptions.module.scss"

export const Descriptions = ({
  flex,
  grid,
  isLoading,
  layout = "vertical",
  bordered = true,
  colon = false,
  size = "small",
  classes = {},
  ...props
}: DescriptionsProps) => {
  if (flex) {
    const { items } = props

    return (items || []).map((item, index) => (
      <div key={index} className={cn(styles.itemFlex, item.className)}>
        <span className={styles.labelFlex}>{item.label}</span>
        <span className={styles.valueFlex}>{item.children}</span>
      </div>
    ))
  }

  if (grid) {
    const { items } = props

    return (
      <div className={cn(styles.grid, classes.grid)}>
        {isLoading && <Skeleton active className={styles.loading} />}
        {!isLoading &&
          (items || []).map((item, index) => {
            const { span, classNames = {} } = item
            const isFullRow = span === 2
            const labelClassName = cn(
              {
                [styles.labelFullRow]: isFullRow,
                [styles.labelAlignSelfStart]: span === -1
              },
              classNames.label
            )

            return (
              <Fragment key={index}>
                <span className={labelClassName} data-id="label">
                  {item.label}
                </span>
                {!isFullRow && (
                  <span className={classNames.content} data-id="content">
                    {item.children}
                  </span>
                )}
              </Fragment>
            )
          })}
      </div>
    )
  }

  if (bordered) {
    return (
      <DescriptionsAntd
        bordered={bordered}
        colon={colon}
        size={size}
        layout={layout}
        {...props}
      />
    )
  }

  return (
    <div className={styles.noBorder}>
      <DescriptionsAntd
        bordered
        colon={colon}
        size={size}
        layout={layout}
        {...props}
      />
    </div>
  )
}

Descriptions.Label = LabelDescriptions
Descriptions.Title = TitleDescriptions
Descriptions.Item = DescriptionsAntd.Item
Descriptions.Divider = DividerDescription
